module.exports = __webpack_public_path__ + "img/education-icon-hover.a48ed46c.png";